import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Combine class names + dedupe Tailwind conflicts. The de facto standard
// helper for shadcn-style projects; lets callers override variants without
// worrying about specificity.
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
